import { render } from "./OperatorStorageDashboard.vue?vue&type=template&id=58b14fd1&scoped=true"
import script from "./OperatorStorageDashboard.vue?vue&type=script&lang=js"
export * from "./OperatorStorageDashboard.vue?vue&type=script&lang=js"

import "./OperatorStorageDashboard.vue?vue&type=style&index=0&id=58b14fd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b14fd1"]])

export default __exports__